import React from 'react'
import update from 'immutability-helper'
import DropzoneComponent from 'react-dropzone-component';
import PaymentRecurringSelect from '../../helpers/General/PaymentRecurringSelect'
import UnitedStatesSelect from '../../helpers/General/UnitedStatesSelect';
import { browserHistory } from 'react-router'


import { listing } from '../../core/controllers/Listing';
import { property }from '../../core/controllers/Property';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { modal } from '../../core/utilities/modal'
import { documents } from '../../core/controllers/Documents';

import PropertiesSelect from '../Properties/PropertiesSelect.jsx';

// #  TODO move this to seperate component
const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.data.storage_id}>
            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6">
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                <img src={attachment.url} width="100px" height="100px" />
                </a>
            </div>
        </attachment>
    );
};

export default class ListingEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listingId : props.listingId,
            images: null,
            sortID: null,
            listing: {
                name: '',
                description: ''
            },
            selectedProperty: null,
            selectedUnitIds: [],
            property_id: 0
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newListing){
            listing.getListing(this.props.listingId, function(response) {
                const details = response.data.details;
                const units = response.data.units;
                var listing = {
                    description: details.listing_description,
                    name: details.listing_name
                };

                var selectedUnitIds = [];
                if (units != false && units.length > 0) {
                    units.forEach(unit => {
                        selectedUnitIds.push(unit.property_unit_id);
                    })
                }

                property.getProperty(details.property_id, function(propertyDetails) {
                    self.setState({
                        property_id: details.property_id,
                        selectedProperty: propertyDetails.data,
                        listing: listing,
                        images: response.data.images,
                        selectedUnitIds: selectedUnitIds
                    });
                });
            });
        }

        dropZone.setup(this, 'listingimages', this.state.listingId);
    }

    triggerUpload(id) {
        var self = this;
        if(id != 0) {
            dropZone.setup(this, 'listingimages', id, true);
        }

        if(dropZone.dropZone.files.length > 0) {
            dropZone.upload(function() {
                if(self.props.newListing) {
                    browserHistory.goBack();
                } else {
                    listing.getListing(self.props.listingId, function(response) {
                        const details = response.data.details;
                        const units = response.data.units;
                        var listing = {
                            description: details.listing_description,
                            name: details.listing_name
                        };

                        var selectedUnitIds = [];
                        if (units != false && units.length > 0) {
                            units.forEach(unit => {
                                selectedUnitIds.push(unit.property_unit_id);
                            })
                        }

                        property.getProperty(details.property_id, function(propertyDetails) {
                            self.setState({
                                property_id: details.property_id,
                                selectedProperty: propertyDetails.data,
                                listing: listing,
                                images: response.data.images,
                                selectedUnitIds: selectedUnitIds
                            });
                        });
                    });
                }
            });
        } else {
            if(self.props.newListing) {
                browserHistory.goBack();
            } else {
                listing.getListing(self.props.listingId, function(response) {
                    const details = response.data.details;
                    const units = response.data.units;
                    var listing = {
                        description: details.listing_description,
                        name: details.listing_name
                    };
                    var selectedUnitIds = [];
                    if (units != false && units.length > 0) {
                        units.forEach(unit => {
                            selectedUnitIds.push(unit.property_unit_id);
                        })
                    }
                    property.getProperty(details.property_id, function(propertyDetails) {
                        self.setState({
                            property_id: details.property_id,
                            selectedProperty: propertyDetails.data,
                            listing: listing,
                            images: response.data.images,
                            selectedUnitIds: selectedUnitIds
                        });
                    });
                });
            }
        }
    }

    validate() {
        const enteredData = this.state.listing;
        const title = enteredData.name;
        const description = enteredData.description;
        const property_id = this.state.property_id;

        if(title === undefined || title.length == 0) {
            modal.showInfo("You need to provide a title for this listing.", "warning", "top", "center");
            return false;
        }

        if(description == "" || description.length == 0) {
            modal.showInfo("Describe this listing.", "warning", "top", "center");
            return false;
        }

        if(property_id == "0" || property_id == 0) {
            modal.showInfo("Which property should be listed?", "warning", "top", "center");
            return false;
        }

        return true;
    }

    handleSaveListingData(e){
        if(!this.validate()) {
            return;
        }

        var self = this;
        listing.saveListing(this.state, function(response) {
            self.triggerUpload(response.data.listing_id);
            modal.showInfo("Listing added!", "success", "top", "center");
        });
    }

    deleteListing(e){
        listing.deleteListing(this.state.listingId, function(response) {
            browserHistory.goBack();
            modal.showInfo("Listing deleted!", "success", "top", "center");
        });
    }

    updateListing(e){
        var self = this;
        listing.updateListing(this.state, function(response) {
            self.triggerUpload(response.data.listing_id);
            modal.showInfo("Listing updated!", "success", "top", "center");
        });
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.data.storage_id, function() {
            listing.removedImage(attachment.data.storage_id, function() {
                listing.getListing(self.props.listingId, function(response) {
                    const details = response.data.details;
                    const units = response.data.units;
                    var listing = {
                        description: details.listing_description,
                        name: details.listing_name
                    };
                    var selectedUnitIds = [];
                    if (units != false && units.length > 0) {
                        units.forEach(unit => {
                            selectedUnitIds.push(unit.property_unit_id);
                        })
                    }
                    property.getProperty(details.property_id, function(propertyDetails) {
                        self.setState({
                            property_id: details.property_id,
                            selectedProperty: propertyDetails.data,
                            listing: listing,
                            images: response.data.images,
                            selectedUnitIds: selectedUnitIds
                        });
                    });
                });
            });
        });
    }

    handleTitleChange(e){
        this.setState({
            listing: update(this.state.listing, {
                name: {$set: e.target.value
                }}
            )
        });
    }

    handleDescriptionChange(e){
        this.setState({
            listing: update(this.state.listing, {
                description: {$set: e.target.value
                }}
            )
        });
    }

    onPropertyTypeChange(e) {
        this.setState({
            listing: update(this.state.listing, {
                property_type: {$set: e.target.value
                }}
            )
        });
    }

    multipleUnits(e) {
        this.setState({
            singleUnit: false
        })
    }

    singleUnit(e) {
        this.setState({
            singleUnit: true
        })
    }

    handleUnitChange(position, e) {
        var copy = this.state.totalUnits.map((item, key) => {
            if (key == position) {
                item.name = e.target.value;
            }

            return item;
        })
        this.setState({totalUnits: copy});
    }

    selectedUnit(id) {
        var didFind = false;
        var selectedUnitIds = this.state.selectedUnitIds.filter((storedId, index) => {
            if (id == storedId) {
                didFind = true
            } else {
                return storedId;
            }
        });

        if (!didFind) {
            selectedUnitIds.push(id);
        }
        this.setState({
            selectedUnitIds: selectedUnitIds
        })
    }

    handlePropertyChange(e) {
        var self = this;
        var value = e.target.value;
        if (value == 0) {
            self.setState({
                property_id: value,
                selectedProperty: null,
                selectedUnitIds: []
            });
        } else {
            property.getProperty(value, function(response) {
                self.setState({
                    property_id: value,
                    selectedProperty: response.data
                });
            });
        }
    }

    addUnit() {
        var copy = this.state.totalUnits;
        copy.push({name: ''});
        this.setState({totalUnits: copy});
    }

    removeUnit(key) {
        var copy = this.state.totalUnits;
        copy.splice(key, 1);
        this.setState({totalUnits: copy});
    }

    renderAttachment(images) {
        var self = this;
        if (images != null && images.length > 0) {
            if(images.length > 0) {
                return images.map((image, index) => (
                    <Attachment key={index} attachment={image} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            }
        }
        else return (<p>No listing images found. </p>);
    }

    render(){
        var self = this;
        const images = this.renderAttachment(this.state.images);
        const newListing = this.props.newListing;
        const listingName = this.state.listing.name;
        const listingDescription = this.state.listing.description;
        const property_id = this.state.property_id;
        const selectedProperty = this.state.selectedProperty;
        const selectedUnitIds = this.state.selectedUnitIds;
        var units = null;
        var singleUnit = true;

        if (selectedProperty != null) {
            if (selectedProperty.units_tally != 0) {
                singleUnit = false;
                units = selectedProperty.units.map((unit, index) => {
                    var selected = false
                    selectedUnitIds.forEach(id => {
                        if(unit.property_unit_id == id) {
                            selected = true
                        }
                    });

                    return selected == true ? (
                        <div class="form-group" key={index}>
                            <label for="unitname">Unit Name</label>
                            <input type="text" class="form-control selectable-unit selected-unit property-unit" value={unit.unit_name} name="unitname" disabled onClick={self.selectedUnit.bind(self, unit.property_unit_id)}/>
                        </div>
                    ) : (
                        <div class="form-group" key={index}>
                            <label for="unitname">Unit Name</label>
                            <input type="text" class="form-control selectable-unit property-unit" value={unit.unit_name} name="unitname" disabled onClick={self.selectedUnit.bind(self, unit.property_unit_id)}/>
                        </div>
                    )
                });
            }
        }

         if (newListing) {
            return (
                <div>
                <div class="row blue-bottom-margin">
                    <div class="row">
                        <div class="sub-page-header-row col-md-11">
                            <div class="row">
                                <span class="sub-page-header-title">Add a Listing</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Listing Information</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <div class="row">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-5 col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <label for="assignee">Listing Name</label>
                                                    <input type="text" value={listingName} class="form-control tenant-info" name="title" placeholder="Backster building..." id="title" onChange={this.handleTitleChange.bind(this)}/>
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                                <div class="form-group">
                                                    <label for="assignee">Listing Details</label>
                                                    <input type="text" value={listingDescription} class="form-control tenant-info" name="title" placeholder="One bedroom & One Bath" id="title" onChange={this.handleDescriptionChange.bind(this)}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-12 card">
                            <div class="card">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="header">
                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-house-outline"></i></span> Property</h4>
                                            <p class="category"></p>
                                        </div>
                                        <div class="col-md-8 col-md-offset-2">
                                            <div class="form-group">
                                                <PropertiesSelect columnSize={0} sortID={property_id} title="" onChange={this.handlePropertyChange.bind(this)} />
                                            </div>
                                        </div>
                                        { selectedProperty != null && (
                                        <div class="row">
                                            <div class="col-md-9 col-md-offset-1">
                                                { selectedProperty.photo == null ? (
                                                <div class="property-photo">
                                                    <p>No property cover image.</p>
                                                </div>
                                                ) : (
                                                <div class="property-photo">
                                                    <img src={selectedProperty.photo.url} width="100%" />
                                                </div>
                                                )}
                                                <div class="header">
                                                    <h4 class="title">{selectedProperty.details.property_name}</h4>
                                                    <p class="category">{selectedProperty.details.property_address}<br/>{selectedProperty.details.property_city} {selectedProperty.details.property_state}, {selectedProperty.details.property_zip}</p>
                                                </div>
                                            </div>
                                        </div>
                                        )}
                                        { singleUnit == false && (
                                        <div class="row">
                                            <div class="col-md-9 col-md-offset-1">
                                                <p>Select one or multiple units to list, otherwise we will list just the property.</p>
                                                {units}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="header">
                                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle" style={{paddingTop:"4px"}}><i class="icon-picture"></i></span> Listing Photos</h4>
                                        <p class="category">Upload listing images to display.</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                            { this.state.dropZoneSetup !== undefined && (
                                                <DropzoneComponent config={this.state.dropZoneConfig}
                                                    eventHandlers={this.state.dropZoneEventHandlers}
                                                    djsConfig={this.state.dropZoneJSConfig} />
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        <div class="col-md-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveListingData.bind(this)}>
                            Add Listing
                            </button>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
                </div>
            )
        } else {
            return (
                <div>
                <div class="row blue-bottom-margin">
                    <div class="row">
                        <div class="sub-page-header-row col-md-11">
                            <div class="row">
                                <span class="sub-page-header-title">{listingName}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Listing Information</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label for="assignee">Listing Name</label>
                                                <input type="text" value={listingName} class="form-control tenant-info" name="title" placeholder="Backster building..." id="title" onChange={this.handleTitleChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <div class="form-group">
                                                <label for="assignee">Listing Details</label>
                                                <input type="text" value={listingDescription} class="form-control tenant-info" name="title" placeholder="One bedroom & One Bath" id="title" onChange={this.handleDescriptionChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-12 card">
                            <div class="card">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="header">
                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-house-outline"></i></span> Property</h4>
                                            <p class="category"></p>
                                        </div>
                                        <div class="col-md-8 col-md-offset-2">
                                            <div class="form-group">
                                                <PropertiesSelect columnSize={0} sortID={property_id} title="" onChange={this.handlePropertyChange.bind(this)} />
                                            </div>
                                        </div>
                                        { selectedProperty != null && (
                                        <div class="row">
                                            <div class="col-md-9 col-md-offset-1">
                                                { selectedProperty.photo == null ? (
                                                <div class="property-photo">
                                                    <p>No property cover image.</p>
                                                </div>
                                                ) : (
                                                <div class="property-photo">
                                                    <img src={selectedProperty.photo.url} width="100%" />
                                                </div>
                                                )}
                                                <div class="header">
                                                    <h4 class="title">{selectedProperty.details.property_name}</h4>
                                                    <p class="category">{selectedProperty.details.property_address}<br/>{selectedProperty.details.property_city} {selectedProperty.details.property_state}, {selectedProperty.details.property_zip}</p>
                                                </div>
                                            </div>
                                        </div>
                                        )}
                                        { singleUnit == false && (
                                        <div class="row">
                                            <div class="col-md-9 col-md-offset-1">
                                                <p>Select one or multiple units to list, otherwise we will list just the property.</p>
                                                {units}
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="header">
                                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle" style={{paddingTop:"4px"}}><i class="icon-picture"></i></span> Listing Photos</h4>
                                        <p class="category"></p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                                { images }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                            { this.state.dropZoneSetup !== undefined && (
                                                <DropzoneComponent config={this.state.dropZoneConfig}
                                                    eventHandlers={this.state.dropZoneEventHandlers}
                                                    djsConfig={this.state.dropZoneJSConfig} />
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteListing.bind(this)}>
                            Delete Listing
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.updateListing.bind(this)}>
                            Update Listing
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Listings/ListingEdit.jsx